import { render, staticRenderFns } from "./GenerateDocuments.vue?vue&type=template&id=5f2c41be&"
import script from "./GenerateDocuments.vue?vue&type=script&lang=js&"
export * from "./GenerateDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports